import { type AuthorModel } from '@/shared/api'
import { showDeleteConfirmationModal } from '@/shared/lib/antd-utils'
import { COMMON_COLUMN_WIDTH } from '@/shared/lib/styling'
import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import { Button, Space, type TableProps } from 'antd'
import { useUnit } from 'effector-react'

import { type AuthorsSortState } from '../../lib/authors-query-model'
import { authorDeleted } from '../../model/author.model'

interface useAuthorsTableColumnsProps {
  onEdit: (authorId: string) => void
  sort: AuthorsSortState
}
export const useAuthorsTableColumns = ({
  onEdit: handleEdit,
  sort,
}: useAuthorsTableColumnsProps): TableProps<AuthorModel>['columns'] => {
  const deleteAuthor = useUnit(authorDeleted)
  const handleDelete = (id: string) => {
    showDeleteConfirmationModal({
      onConfirm: () => {
        deleteAuthor({ id })
      },
    })
  }

  return [
    {
      title: 'Наименование',
      dataIndex: 'nickname',
      key: 'nickname',
      sorter: true,
      ellipsis: true,
      sortOrder:
        sort.field === 'nickname'
          ? sort.order === 'asc'
            ? 'ascend'
            : sort.order === 'desc'
              ? 'descend'
              : null
          : null,
      render: (_, author) => author.nickname,
    },
    {
      title: '',
      width: COMMON_COLUMN_WIDTH.ACTIONS,
      key: 'actions',
      align: 'center',
      render: (_, author) => (
        <Space size="middle">
          <Button
            onClick={() => handleEdit(author.id)}
            icon={<EditOutlined />}
          />
          <Button
            onClick={() => handleDelete(author.id)}
            icon={<DeleteOutlined style={{ color: 'red' }} />}
          />
        </Space>
      ),
    },
  ]
}
